import type { Account } from '@repo/api-gw-sdk';

import { PanelWrapper } from '@/components/panels/panelWrapper';

import { SourceAccountConfigTabs } from './sourceAccountConfigTabs';

interface SourceAccountConfigPanelProps {
  account: Account;
  onClose: () => void;
}

export function SourceAccountConfigPanel(props: SourceAccountConfigPanelProps) {
  return (
    <PanelWrapper
      testIdPrefix='source-account-config'
      header={{
        hideBorder: true,
        title: 'Source Account Configuration',
        onBack: props.onClose,
        onClose: props.onClose,
      }}
    >
      <SourceAccountConfigTabs
        account={props.account}
        onClose={props.onClose}
      />
    </PanelWrapper>
  );
}
